<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <good-table-column-search
              :moduleapi="`${baseApi}/phone-extension`"
              :columns="columns"
              routerpath="/master/hr/phoneextension/addphoneextension"
              :formOptions="formOptions"
              :newPage="true"
              title="Phone Extension"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoodTableColumnSearch from '@/components/GoodTableColumnSearch.vue'
import { buildPhoneExtensionFormOptions } from './phoneExtensionFormOptions'

const baseApi = process.env.VUE_APP_APIENDPOINT

export default {
  components: {
    GoodTableColumnSearch
  },
  data () {
    return {
      baseApi,
      formOptions: buildPhoneExtensionFormOptions(this.$route),
      columns: [
        { label: 'Label', field: 'label' },
        { label: 'Extension', field: 'extension' },
        { label: 'SIP Username', field: 'sip_username' },
        { label: 'Assigned User', field: 'user.fullname' },
        { label: 'Display Name', field: 'display_name' },
        { label: 'WSS Server', field: 'ws_server' },
        { label: 'SIP Domain', field: 'sip_domain' }
      ]
    }
  }
}
</script>
